import { api } from './api'

export interface PagaleveEligibilityRequest {
  cpf: string
  amount: number
  phone: string
  email: string
}

export interface PagaleveEligibilityResponse {
  success: boolean
  data?: {
    eligible?: boolean
    [key: string]: any
  }
  message?: string
}

export async function checkPagaleveEligibility(
  data: PagaleveEligibilityRequest
): Promise<boolean> {
  try {
    console.log('checkPagaleveEligibility', data)
    if (!data.cpf || !data.amount || !data.phone || !data.email) {
      console.warn('Dados incompletos para verificação de elegibilidade Pagaleve')
      return false
    }

    const cleanCPF = data.cpf.replace(/\D/g, '')
    const cleanPhone = data.phone.replace(/\D/g, '')

    const payload = {
      cpf: cleanCPF,
      amount: data.amount,
      phone: cleanPhone,
      email: data.email,
    }

    const response = await api.post<PagaleveEligibilityResponse>('/payments/pagaleve/eligibility', payload)

    if (response.data?.success && response.data?.data) {
      const isEligible = response.data.data.eligible === true
      console.log(`Cliente ${isEligible ? 'ELEGÍVEL' : 'NÃO ELEGÍVEL'} para Pagaleve`)
      return isEligible
    }

    return false
  } catch (error: any) {
    console.error('Erro ao verificar elegibilidade Pagaleve:', error?.response?.data || error?.message)
    return false
  }
}

